import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { CounterSection as CounterSectionI } from "../../types/interfaces/CounterSection";
import { CounterSectionCss } from "./CounterSectionCss";

const CounterSection = (counters: CounterSectionI) => {
  const [counts, setCounts] = useState(counters.countObjects.map(() => 0));

  useEffect(() => {
    const interval = setInterval(() => {
      setCounts((prevCounts) =>
        prevCounts.map((count, index) => {
          const targetCount = counters.countObjects[index].count;
          const increment = targetCount > count ? 1 : 0;
          return count + increment;
        })
      );
    }, 1);

    return () => clearInterval(interval);
  });

  return (
    <div
      style={CounterSectionCss.main}
      className="event-site-info-wrap bg-black section-pt-90 section-pb-90"
    >
      <Container>
        <Row className="row-cols-lg-4 row-cols-sm-2 row-cols-1">
          {counters.countObjects.map((item, index) => (
            <Col key={index} className="mb-30">
              <div className="funfact-wrap text-center">
                <h2 className="value" style={CounterSectionCss.value}>
                  <span
                    className="odometer odometer-auto-theme"
                    data-count-to={item.count}
                  >
                    {counts[index]}+
                  </span>
                </h2>
                <h3 style={CounterSectionCss.title} className="title">
                  {item.title}
                </h3>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default CounterSection;
